/* eslint-disable react/no-set-state */
import PropTypes from 'prop-types';

import { Component } from 'react';
import outsideClick from 'react-click-outside';

@outsideClick
export default class OutsideClick extends Component {
  static propTypes = {
    onClickOutside: PropTypes.func.isRequired,
    onRender: PropTypes.func.isRequired,
  };

  handleClickOutside() {
    const { onClickOutside } = this.props;
    onClickOutside();
  }

  render() {
    const { onRender } = this.props;
    return onRender();
  }
}
